import { DisciplineFilterOptionInformation } from '@studyportals/search-filters';
import { disciplineGetDefaultIcon } from '@studyportals/search-filters';
import { disciplinesAll } from '@studyportals/static-domain-data/disciplines/disciplines';
import { subdisciplinesAll } from '@studyportals/static-domain-data/disciplines/subdisciplines';
import { disciplineGetVirtualPath } from '@studyportals/static-domain-data/disciplines/discipline-get-virtual-path';
import { Discipline } from '@/router/fragments/fragment-items/Discipline';

class DisciplinePresenter {
	public allOptions(): DisciplineFilterOptionInformation[] {
		const disciplineOptions = disciplinesAll.map((d) => {
			return new DisciplineFilterOptionInformation(
				d.name,
				d.id.toString(),
				'',
				d.name,
				undefined,
				disciplineGetDefaultIcon(d.id),
				''
			);
		});

		const subdisciplineOptions = subdisciplinesAll.map((s) => {
			return new DisciplineFilterOptionInformation(
				s.name,
				s.id.toString(),
				'',
				s.name,
				s.disciplineId.toString(),
				disciplineGetDefaultIcon(s.id),
				''
			);
		});

		return [...disciplineOptions, ...subdisciplineOptions];
	}

	public allWithPaths(): Discipline[] {
		const disciplines: Discipline[] = [];

		[...disciplinesAll, ...subdisciplinesAll].forEach((discipline) => {
			const path = disciplineGetVirtualPath(discipline.id);
			if (path === null) {
				return;
			}
			disciplines.push(new Discipline(discipline.id, path));
		});

		return disciplines;
	}
}

const disciplinePresenterInstance = new DisciplinePresenter();

export { disciplinePresenterInstance as DisciplinePresenter };
